import type { SiteContent } from '../domain/site-content.js';
import type { StrapiSiteContentResponse } from '../wire/site-content.js';

/**
 * The CMS is the only source of editorial copy, so there is nothing to merge:
 * the wire schema requires every leaf, which means a parsed entry already IS
 * a complete SiteContent once Strapi's own entity fields are dropped.
 *
 * An incomplete entry never reaches here — zod rejects it in the api-client
 * and the app shows its retry screen. That is deliberate: a page with missing
 * strings is worse than a page that says it could not load.
 */
export const mapSiteContent = (
  wire: StrapiSiteContentResponse,
): SiteContent => {
  const { id, documentId, createdAt, updatedAt, publishedAt, ...content } =
    wire;
  void id;
  void documentId;
  void createdAt;
  void updatedAt;
  void publishedAt;
  return content;
};
